module.exports = __webpack_public_path__ + "img/QB60.e47b75ee.jpg";